/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const frequencyJSON = async (): Promise<any> => {
  const frequency = useJSONStore.getState().frequency;
  const token = useUserStore.getState().userToken;
  const setFrequency = useJSONStore.getState().setFrequency;

  if (frequency.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.frequency}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setFrequency(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default frequencyJSON;
